<div class="flex basis-full content-''">
  <h1 class="text-left basis-full content-''">{{ 'GENERAL.REMOVALS' | appString }}</h1>

  <div class="text-right justify-end content-center basis-full content-''">
    <button class="mx-1" (click)="save()">{{ 'GENERAL.SAVE' | appString }}</button>
  </div>
</div>

<div class="mat-elevation-z8 rounded-md overflow-hidden">
  <div class="grid grid-cols-[1.2fr_0.9fr_1.2fr_1.2fr_1.4fr_1.4fr] items-center gap-1 md:gap-2 bg-segesblue50 px-1 md:px-3 py-2 text-center text-4xl font-bold leading-tight">
    <div>{{ 'GENERAL.DATE' | appString }}</div>
    <div>{{ 'GENERAL.PEN' | appString }}</div>
    <div>{{ 'GENERAL.NUMBEROFANIMALS' | appString }}</div>
    <div>{{ 'GENERAL.WEIGHTINKG' | appString }}</div>
    <div>{{ 'GENERAL.CODE' | appString }}</div>
    <div>{{ 'GENERAL.REASON' | appString }}</div>
  </div>

  @for (row of removalRows(); track $index) {
    <div [formGroup]="row.form" class="grid grid-cols-[1.2fr_0.9fr_1.2fr_1.2fr_1.4fr_1.4fr] items-center gap-1 md:gap-2 px-1 md:px-3 py-2 text-center odd:bg-white even:bg-gray-100 hover:bg-segeslightblue50 focus-within:bg-segeslightblue80">
      <input class="w-full min-w-0 bg-white border rounded-xl px-1 py-1 text-xs md:text-sm lg:text-lg" matInput type="date" formControlName="date">
      <input
        [decimals]="0"
        class="w-full min-w-0 text-sm md:text-lg lg:text-4xl text-center bg-white border rounded-xl"
        matInput
        [min]="1"
        [max]="999"
        [minValue]="1"
        [maxValue]="999"
        InputPositiveInteger
        type="text"
        inputmode="numeric"
        formControlName="pen">
      <input
        [decimals]="0"
        class="w-full min-w-0 text-sm md:text-lg lg:text-4xl text-center bg-white border rounded-xl"
        matInput
        [min]="1"
        [max]="99"
        [minValue]="1"
        [maxValue]="99"
        InputPositiveInteger
        type="text"
        inputmode="numeric"
        formControlName="numberOfAnimals">
      <input
        [decimals]="1"
        class="w-full min-w-0 text-sm md:text-lg lg:text-4xl text-center bg-white border rounded-xl"
        matInput
        [min]="0.1"
        [max]="999.9"
        [minValue]="0.1"
        [maxValue]="999.9"
        InputPositiveInteger
        type="text"
        inputmode="numeric"
        formControlName="weight">
      <mat-select class="w-full min-w-0 rounded-xl border bg-white px-1 py-2 text-left text-xs md:text-sm lg:text-lg" formControlName="code">
        <mat-option value="" aria-label="Blank">&nbsp;</mat-option>
        @for (code of removalCodes; track code) {
          <mat-option [value]="code">{{ code }}</mat-option>
        }
      </mat-select>
      <mat-select class="w-full min-w-0 rounded-xl border bg-white px-1 py-2 text-left text-xs md:text-sm lg:text-lg" formControlName="reason">
        <mat-option value="" aria-label="Blank">&nbsp;</mat-option>
        @for (reason of removalReasons; track reason) {
          <mat-option [value]="reason">{{ reason }}</mat-option>
        }
      </mat-select>
    </div>
  }
</div>